import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePriestAuth } from '../context/PriestAuthContext';

export default function PriestSignup() {
  const { signup, loading, error, clearError, priest } = usePriestAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '', email: '', phone: '', gotram: '', kulaDeity: '',
    password: '', confirm: '',
  });
  const [showPw, setShowPw] = useState(false);
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [formError, setFormError] = useState('');

  useEffect(() => { if (priest) navigate('/priest/dashboard', { replace: true }); }, [priest, navigate]);
  useEffect(() => { clearError(); }, []); // eslint-disable-line

  const onChange = (e) => {
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));
    setFormError('');
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim())  return setFormError('Name is required');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return setFormError('Valid email is required');
    if (form.phone.trim() && !/^\+?[0-9]{10,15}$/.test(form.phone.trim())) return setFormError('Enter a valid mobile number (10-15 digits)');
    if (form.password.length < 8) return setFormError('Password must be at least 8 characters');
    if (form.password !== form.confirm) return setFormError('Passwords do not match');
    if (!ageConfirmed) return setFormError('You must confirm that you are 18 years or older');
    try {
      await signup({
        name: form.name.trim(), email: form.email.trim(), phone: form.phone.trim(),
        gotram: form.gotram.trim(), kulaDeity: form.kulaDeity.trim(),
        password: form.password,
      });
      navigate('/priest/dashboard', { replace: true });
    } catch { /* shown via error */ }
  };

  return (
    <div className="auth-page">
      <div className="auth-card priest-auth-card" style={{ maxWidth: 520 }}>
        <div className="auth-header">
          <span className="auth-icon">🪔</span>
          <h1>Purohit Registration</h1>
          <p>Create your priest dashboard account</p>
        </div>

        <form onSubmit={onSubmit} noValidate>
          {(formError || error) && (
            <div className="auth-error"><span>⚠️</span> {formError || error}</div>
          )}

          <div className="form-row-2">
            <div className="form-group">
              <label>Full Name *</label>
              <input name="name" value={form.name} onChange={onChange} disabled={loading} />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input name="phone" type="tel" placeholder="9876543210" value={form.phone} onChange={onChange} disabled={loading} />
            </div>
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input name="email" type="email" value={form.email} onChange={onChange} disabled={loading} />
          </div>

          <div className="form-row-2">
            <div className="form-group">
              <label>Gotram</label>
              <input name="gotram" value={form.gotram} onChange={onChange} disabled={loading} />
            </div>
            <div className="form-group">
              <label>Kula Deity</label>
              <input name="kulaDeity" value={form.kulaDeity} onChange={onChange} disabled={loading} />
            </div>
          </div>

          <div className="form-group">
            <label>Password *</label>
            <div className="auth-input-wrapper">
              <input name="password" type={showPw ? 'text' : 'password'} autoComplete="off"
                value={form.password} onChange={onChange} disabled={loading} />
              <button type="button" className="auth-toggle-pw" onClick={() => setShowPw(v => !v)}>
                {showPw ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label>Confirm Password *</label>
            <input name="confirm" type={showPw ? 'text' : 'password'} autoComplete="off"
              value={form.confirm} onChange={onChange} disabled={loading} />
          </div>

          <p className="auth-consent-text" style={{ fontSize: '0.82rem', color: '#888', margin: '1rem 0 0.5rem', lineHeight: 1.5 }}>
            By creating an account, you agree to our{' '}
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>,{' '}
            <Link to="/privacy-policy">Privacy Policy</Link>, and{' '}
            <Link to="/priest/terms">Priest Terms of Service</Link>.
          </p>

          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.82rem', color: '#888', margin: '0.5rem 0 1rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={ageConfirmed}
              onChange={(e) => setAgeConfirmed(e.target.checked)}
              style={{ width: '16px', height: '16px', cursor: 'pointer' }}
            />
            I confirm that I am 18 years of age or older.
          </label>

          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
            {loading ? <span className="auth-spinner" /> : 'Register Priest Account 🕉️'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already registered? <Link to="/priest/login" className="auth-link">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
}
